// import "./App.css";
// import { Routes, Route, Navigate } from "react-router";
// import HomePage from "./pages/HomePage";
// import ServicePage from "./pages/ServicePage";
// import Navbar from "./components/common/Navbar";
// import Footerbar from "./components/common/Footerbar";
// import AboutUs from "./pages/AboutUs";
// import ContactPage from "./pages/ContactPage";
// import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
// import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
// import Bill from "./pages/Bill";
// import { useLocation } from "react-router";
// import WhatsAppQuicButton from "./components/common/WhatsAppQuicButton";
// import BookAppointmentNew2 from "./pages/BookAppointmentNew2";
// import WordPage from "./pages/WordPage";
// import WordAndRoomSinglePage from "./pages/singlePages/WordAndRoomSinglePage";
// import BlogPage from "./pages/BlogPage";
// import BlogArticalSinglePage from "./pages/singlePages/BlogArticalSinglePage";
// import CareersPage from "./pages/CareersPage";
// import GalleryPage from "./pages/GalleryPage";

// function App() {
//   const location = useLocation();
//   return (
//     <>
//       <div className="scroll-smooth">
//         <Navbar />
//         <Routes>
//           <Route index element={<HomePage />} />
//           <Route path="*" element={<Navigate to="/" replace />} />
//           <Route path="/service" element={<ServicePage />} />
//           <Route path="/about-us" element={<AboutUs />} />
//           <Route path="/contact-us" element={<ContactPage />} />
//           <Route path="/pages/gallery" element={<GalleryPage />} />
//           <Route path="/careers" element={<CareersPage />} />
//           <Route path="/pages/blogs" element={<BlogPage />} />
//           <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
//           <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
//           <Route path="/book-appointment" element={<BookAppointmentNew2 />} />
//           <Route path="/bill/:ref" element={<Bill />} />
//           <Route path="/service/ch-ward" element={<WordPage />} />
//           <Route path="/service/ch-ward/ward-details/:encryptedId" element={<WordAndRoomSinglePage />} />
//           <Route path="/pages/blogs/blog-article/:encryptedId" element={<BlogArticalSinglePage />} />
//         </Routes>
//         <WhatsAppQuicButton />
//         {!location.pathname.startsWith("/bill/") && <Footerbar />}
//       </div>
//     </>
//   );
// }

// export default App;

// Duplicate//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// import "./App.css";
// import { Routes, Route, Navigate } from "react-router";
// import { useLocation } from "react-router-dom";
// import HomePage from "./pages/HomePage";
// import ServicePage from "./pages/ServicePage";
// import Navbar from "./components/common/Navbar";
// import Footerbar from "./components/common/Footerbar";
// import AboutUs from "./pages/AboutUs";
// import ContactPage from "./pages/ContactPage";
// import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
// import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
// import Bill from "./pages/Bill";
// import WhatsAppQuicButton from "./components/common/WhatsAppQuicButton";
// import BookAppointmentNew2 from "./pages/BookAppointmentNew2";
// import WordPage from "./pages/WordPage";
// import WordAndRoomSinglePage from "./pages/singlePages/WordAndRoomSinglePage";
// import BlogPage from "./pages/BlogPage";
// import BlogArticalSinglePage from "./pages/singlePages/BlogArticalSinglePage";
// import CareersPage from "./pages/CareersPage";
// import GalleryPage from "./pages/GalleryPage";
// import { useEffect, useState } from "react";


// function App() {
//   const location = useLocation();
//   const [selectedCountryCode, setSelectedCountryCode] = useState('US');

//   useEffect(() => {
//     console.log(selectedCountryCode);
//   }, [selectedCountryCode])



//   return (
//     <div className="scroll-smooth">
//       {/* Hidden Google Translate Element */}
//       <div id="google_translate_element" style={{ display: 'none' }}></div>
//       <Navbar />
//       <Routes>
//         <Route index element={<HomePage selectedLanguage={selectedCountryCode} setSelectedLanguage={setSelectedCountryCode} />} />
//         <Route path="*" element={<Navigate to="/" replace />} />
//         <Route path="/service" element={<ServicePage />} />
//         <Route path="/about-us" element={<AboutUs />} />
//         <Route path="/contact-us" element={<ContactPage />} />
//         <Route path="/pages/gallery" element={<GalleryPage />} />
//         <Route path="/careers" element={<CareersPage />} />
//         <Route path="/pages/blogs" element={<BlogPage />} />
//         <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
//         <Route
//           path="/terms-and-conditions"
//           element={<TermsAndConditionsPage />}
//         />
//         <Route path="/book-appointment" element={<BookAppointmentNew2 />} />
//         <Route path="/bill/:ref" element={<Bill />} />
//         <Route path="/service/ch-ward" element={<WordPage />} />
//         <Route
//           path="/service/ch-ward/ward-details/:encryptedId"
//           element={<WordAndRoomSinglePage />}
//         />
//         <Route
//           path="/pages/blogs/blog-article/:encryptedId"
//           element={<BlogArticalSinglePage />}
//         />
//       </Routes>
//       <WhatsAppQuicButton />
//       {!location.pathname.startsWith("/bill/") && <Footerbar />}
//     </div>
//   );
// }

// export default App;



//meka thama hri eka////////////////////////////////////////////////////////////////////////////////////

// import "./App.css";
// import { Routes, Route, Navigate } from "react-router";
// import { useLocation } from "react-router-dom";
// import HomePage from "./pages/HomePage";
// import ServicePage from "./pages/ServicePage";
// import Navbar from "./components/common/Navbar";
// import Footerbar from "./components/common/Footerbar";
// import AboutUs from "./pages/AboutUs";
// import ContactPage from "./pages/ContactPage";
// import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
// import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
// import Bill from "./pages/Bill";
// import WhatsAppQuicButton from "./components/common/WhatsAppQuicButton";
// import BookAppointmentNew2 from "./pages/BookAppointmentNew2";
// import WordPage from "./pages/WordPage";
// import WordAndRoomSinglePage from "./pages/singlePages/WordAndRoomSinglePage";
// import BlogPage from "./pages/BlogPage";
// import BlogArticalSinglePage from "./pages/singlePages/BlogArticalSinglePage";
// import CareersPage from "./pages/CareersPage";
// import GalleryPage from "./pages/GalleryPage";
// import { useEffect, useState } from "react";

// import Snowfall from 'react-snowfall'


// function App() {
//   const location = useLocation();
//   const [currentLang, setCurrentLang] = useState("en");


//   useEffect(() => {
//     // Load Google Translate script
//     const script = document.createElement("script");
//     script.src =
//       "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
//     script.async = true;

//     // Define callback function - use type assertion to avoid TypeScript error
//     (window as any).googleTranslateElementInit = () => {
//       if (window.google?.translate) {
//         try {
//           new window.google.translate.TranslateElement(
//             {
//               pageLanguage: "en",
//               includedLanguages: "en,si,de",
//               layout: 1,
//               autoDisplay: false,
//             },
//             "google_translate_element"
//           );

//           // Hide Google's default UI
//           setTimeout(() => {
//             const googleFrame = document.querySelector<HTMLElement>('.goog-te-banner-frame');
//             const googleCombo = document.querySelector<HTMLElement>('.goog-te-combo');
//             if (googleFrame) googleFrame.style.display = 'none';
//             if (googleCombo) googleCombo.style.display = 'none';
//           }, 500);
//         } catch (error) {
//           console.error("Google Translate initialization error:", error);
//         }
//       }
//     };

//     document.body.appendChild(script);

//     return () => {
//       if (script.parentNode) {
//         script.parentNode.removeChild(script);
//       }
//       // Clean up
//       delete (window as any).googleTranslateElementInit;
//     };
//   }, []);


//   const changeLanguage = (langCode: string) => {
//     setCurrentLang("en");

//     // Set the cookie for Google Translate
//     document.cookie = `googtrans=/en/${langCode}; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT`;

//     // Also store in localStorage for consistency
//     localStorage.setItem('preferredLanguage', langCode);

//     // Reload the page to apply translation
//     window.location.reload();
//   };

//   // Load saved language preference
//   useEffect(() => {
//     const savedLang = localStorage.getItem('preferredLanguage');
//     if (savedLang && ['en', 'si', 'de'].includes(savedLang)) {
//       setCurrentLang(savedLang);
//     }
//   }, []);


//   return (
//     <div className="scroll-smooth">

//       {/* Hidden Google Translate Element */}
//       <div id="google_translate_element" style={{ display: 'none' }}></div>

//       <Navbar />
//       <Routes>
//         <Route index element={<HomePage currentLang={currentLang} changeLanguage={changeLanguage} />} />
//         <Route path="*" element={<Navigate to="/" replace />} />
//         <Route path="/service" element={<ServicePage />} />
//         <Route path="/about-us" element={<AboutUs />} />
//         <Route path="/contact-us" element={<ContactPage />} />
//         <Route path="/pages/gallery" element={<GalleryPage />} />
//         <Route path="/careers" element={<CareersPage />} />
//         <Route path="/pages/blogs" element={<BlogPage />} />
//         <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
//         <Route
//           path="/terms-and-conditions"
//           element={<TermsAndConditionsPage />}
//         />
//         <Route path="/book-appointment" element={<BookAppointmentNew2 />} />
//         <Route path="/bill/:ref" element={<Bill />} />
//         <Route path="/service/ch-ward" element={<WordPage />} />
//         <Route
//           path="/service/ch-ward/ward-details/:encryptedId"
//           element={<WordAndRoomSinglePage />}
//         />
//         <Route
//           path="/pages/blogs/blog-article/:encryptedId"
//           element={<BlogArticalSinglePage />}
//         />
//       </Routes>
//       <WhatsAppQuicButton />
//       {!location.pathname.startsWith("/bill/") && <Footerbar />}
//       <Snowfall />
//     </div>
//   );
// }

// export default App;


////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



import "./App.css";
import { Routes, Route, Navigate } from "react-router";
import { useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ServicePage from "./pages/ServicePage";
import Navbar from "./components/common/Navbar";
import Footerbar from "./components/common/Footerbar";
import AboutUs from "./pages/AboutUs";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import Bill from "./pages/Bill";
import WhatsAppQuicButton from "./components/common/WhatsAppQuicButton";
import BookAppointmentNew2 from "./pages/BookAppointmentNew2";
import WordPage from "./pages/WordPage";
import WordAndRoomSinglePage from "./pages/singlePages/WordAndRoomSinglePage";
import BlogPage from "./pages/BlogPage";
import BlogArticalSinglePage from "./pages/singlePages/BlogArticalSinglePage";
import CareersPage from "./pages/CareersPage";
import GalleryPage from "./pages/GalleryPage";
import { useEffect, useState, useCallback } from "react";
import Snowfall from 'react-snowfall';

// Type declaration for Google Translate - Fixed type definitions
declare global {
  interface Window {
    google?: {
      translate?: {
        TranslateElement: new (
          config: GoogleTranslateElementConfig,
          elementId: string
        ) => void;
      };
    };
    googleTranslateElementInit?: () => void;
  }
}

// Interface for Google Translate configuration
interface GoogleTranslateElementConfig {
  pageLanguage: string;
  includedLanguages?: string;
  layout?: number;
  autoDisplay?: boolean;
  [key: string]: any;
}

function App() {
  const location = useLocation();
  const [currentLang, setCurrentLang] = useState<string>("en");

  // Function to hide ALL Google Translate UI elements
  const hideGoogleTranslateUI = useCallback(() => {
    // List of all Google Translate selectors
    const googleSelectors = [
      '.goog-te-banner-frame',
      '.goog-te-banner',
      '.goog-te-ftab',
      '.VIpgJd-ZVi9od-ORHb-OEVmcd',
      '.VIpgJd-ZVi9od-ORHb',
      '.goog-te-gadget',
      '.goog-te-combo',
      '.goog-te-menu-frame',
      '.goog-te-menu-value',
      '.goog-te-menu',
      '.skiptranslate',
    ];

    // Hide each element
    googleSelectors.forEach(selector => {
      try {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          if (el instanceof HTMLElement) {
            el.style.display = 'none';
            el.style.visibility = 'hidden';
            el.style.opacity = '0';
            el.style.height = '0';
            el.style.width = '0';
            el.style.overflow = 'hidden';
            el.style.position = 'absolute';
            el.style.top = '-9999px';
          }
        });
      } catch (error) {
        // Silently ignore selector errors
      }
    });

    // Remove skiptranslate class to prevent layout shift
    document.documentElement.classList.remove('skiptranslate');
    document.documentElement.style.marginTop = '0';
    document.body.style.marginTop = '0';
    document.body.style.top = '0';
  }, []);

  // Initialize Google Translate
  useEffect(() => {
    // Check if script is already loaded
    if (window.google?.translate) {
      return;
    }

    const script = document.createElement("script");
    script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    script.defer = true;

    // Define initialization callback
    window.googleTranslateElementInit = () => {
      // Use a type-safe approach to check for Google Translate
      const googleTranslate = window.google?.translate;

      if (googleTranslate && googleTranslate.TranslateElement) {
        try {
          // Create config object with only valid properties
          const config: GoogleTranslateElementConfig = {
            pageLanguage: "en",
            includedLanguages: "en,si,de",
            layout: 1, // Simple layout
            autoDisplay: false, // Don't show automatically
          };

          // Add additional properties only if they exist in the type
          // Note: We're using type assertion because Google Translate accepts more properties
          // than defined in the interface
          const extendedConfig = {
            ...config,
            // These are valid Google Translate properties but not in our strict interface
            multilanguagePage: true,
          } as any; // Type assertion to avoid TypeScript errors

          new googleTranslate.TranslateElement(
            extendedConfig,
            "google_translate_element"
          );

          // Hide UI immediately and set up interval to catch dynamic elements
          hideGoogleTranslateUI();

          // Set up MutationObserver to catch dynamically added elements
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.addedNodes.length) {
                hideGoogleTranslateUI();
              }
            });
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });

          // Also hide on DOM changes
          document.addEventListener('DOMNodeInserted', hideGoogleTranslateUI);

          // Clean up after 5 seconds
          setTimeout(() => {
            observer.disconnect();
            document.removeEventListener('DOMNodeInserted', hideGoogleTranslateUI);
            hideGoogleTranslateUI(); // Final cleanup
          }, 5000);

        } catch (error) {
          console.error("Google Translate initialization error:", error);
        }
      }
    };

    document.head.appendChild(script);

    // Cleanup function
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      delete window.googleTranslateElementInit;
    };
  }, [hideGoogleTranslateUI]);

  // Change language function
  const changeLanguage = useCallback((langCode: string) => {
    const allowedLanguages = ['en', 'si', 'de'];

    if (!allowedLanguages.includes(langCode)) {
      console.warn(`Language code ${langCode} is not supported`);
      return;
    }

    setCurrentLang(langCode);
window.location.reload()
    // Set Google Translate cookie
    const cookieValue = `googtrans=/en/${langCode}`;
    const expires = new Date('9999-12-31T23:59:59Z').toUTCString();
    document.cookie = `${cookieValue}; path=/; expires=${expires}; SameSite=Lax`;

    // Store in localStorage for persistence
    localStorage.setItem('preferredLanguage', langCode);

    // Try to programmatically change language without reload
    try {
      const select = document.querySelector<HTMLSelectElement>('.goog-te-combo');
      if (select && select.value !== langCode) {
        select.value = langCode;
        select.dispatchEvent(new Event('change'));

        // Hide UI again after language change
        setTimeout(hideGoogleTranslateUI, 300);
      } else {
        // Fallback to page reload if select not found
        setTimeout(() => window.location.reload(), 100);
      }
    } catch (error) {
      console.error("Error changing language:", error);
      // Fallback to page reload
      setTimeout(() => window.location.reload(), 100);
    }
  }, [hideGoogleTranslateUI]);

  // Load saved language preference
  useEffect(() => {
    const savedLang = localStorage.getItem('preferredLanguage');
    const allowedLanguages = ['en', 'si', 'de'];

    if (savedLang && allowedLanguages.includes(savedLang)) {
      setCurrentLang(savedLang);

      // Apply saved language to Google Translate if loaded
      const googleTranslate = window.google?.translate;
      if (googleTranslate) {
        try {
          const select = document.querySelector<HTMLSelectElement>('.goog-te-combo');
          if (select && select.value !== savedLang) {
            select.value = savedLang;
            select.dispatchEvent(new Event('change'));
          }
        } catch (error) {
          console.error("Error applying saved language:", error);
        }
      }
    }
  }, []);

  // Periodically check and hide Google Translate UI
  useEffect(() => {
    const intervalId = setInterval(() => {
      hideGoogleTranslateUI();
    }, 1000);

    return () => clearInterval(intervalId);
  }, [hideGoogleTranslateUI]);

  // Check if current route is a bill page
  const isBillPage = location.pathname.startsWith("/bill/");




  // useEffect(() => {
  //   if (currentLang) {
  //     window.location.reload()
  //   }
  // }, [currentLang])




  return (
    <div className="scroll-smooth">
      {/* Hidden Google Translate Element - Must be in DOM for Google Translate to work */}
      <div
        id="google_translate_element"
        style={{
          display: 'none',
          position: 'absolute',
          top: '-9999px',
          left: '-9999px',
          width: '0',
          height: '0',
          overflow: 'hidden'
        }}
      />

      <Navbar />

      <Routes>
        <Route
          index
          element={
            <HomePage
              currentLang={currentLang}
              changeLanguage={changeLanguage}
            />
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/service" element={<ServicePage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/pages/gallery" element={<GalleryPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/pages/blogs" element={<BlogPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
        <Route path="/book-appointment" element={<BookAppointmentNew2 />} />
        <Route path="/bill/:ref" element={<Bill />} />
        <Route path="/service/ch-ward" element={<WordPage />} />
        <Route path="/service/ch-ward/ward-details/:encryptedId" element={<WordAndRoomSinglePage />} />
        <Route path="/pages/blogs/blog-article/:encryptedId" element={<BlogArticalSinglePage />} />
      </Routes>

      <WhatsAppQuicButton />
      {!isBillPage && <Footerbar />}

      {/* Optional: Conditionally render Snowfall */}
      <Snowfall
        snowflakeCount={50}
        style={{
          position: 'fixed',
          width: '100vw',
          height: '100vh',
          zIndex: 9999,
          pointerEvents: 'none',
        }}
      />

      <div>

      </div>

    </div>
  );
}

export default App;